import { MIN_PANE } from './constants'

export type SplitMetrics = {
  workspaceHeight: number
  paddingTop: number
  paddingBottom: number
  gap: number
  dividerHeight: number
}

export const splitAvailable = ({ workspaceHeight, paddingTop, paddingBottom, gap, dividerHeight }: SplitMetrics) =>
  workspaceHeight - paddingTop - paddingBottom - dividerHeight - gap * 2

export const clampSplitHeight = (height: number, available: number): number => {
  if (available <= MIN_PANE * 2) return Math.max(80, Math.round(available / 2))
  return Math.min(Math.max(height, MIN_PANE), available - MIN_PANE)
}

export const documentationSplitHeight = ({
  pointerY,
  workspaceTop,
  ...metrics
}: SplitMetrics & { pointerY: number; workspaceTop: number }): number =>
  clampSplitHeight(pointerY - (workspaceTop + metrics.paddingTop), splitAvailable(metrics))
